var _path, _path2, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile2User(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9.02906 11.4C11.6469 11.4 13.7691 9.29574 13.7691 6.7C13.7691 4.10426 11.6469 2 9.02906 2C6.41123 2 4.28906 4.10426 4.28906 6.7C4.28906 9.29574 6.41123 11.4 9.02906 11.4Z",
    fill: "url(#paint0_linear_406_14032)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03 22.0001C12.9126 22.0001 16.06 19.8958 16.06 17.3001C16.06 14.7044 12.9126 12.6001 9.03 12.6001C5.14744 12.6001 2 14.7044 2 17.3001C2 19.8958 5.14744 22.0001 9.03 22.0001Z",
    fill: "url(#paint1_linear_406_14032)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3909 4.00006C15.8407 4.00069 15.2976 4.12366 14.8009 4.36006C15.22 5.37721 15.3558 6.4889 15.1938 7.57704C15.0318 8.66517 14.5781 9.6891 13.8809 10.5401C14.3332 10.952 14.8793 11.2473 15.4716 11.4004C16.064 11.5535 16.6847 11.5597 17.28 11.4185C17.8753 11.2774 18.4272 10.993 18.8877 10.5903C19.3483 10.1875 19.7036 9.67843 19.9228 9.10724C20.142 8.53605 20.2185 7.91999 20.1457 7.31253C20.0729 6.70506 19.853 6.12454 19.505 5.62134C19.157 5.11813 18.6914 4.70745 18.1488 4.42492C17.6061 4.14239 17.0027 3.99655 16.3909 4.00006Z",
    fill: "url(#paint2_linear_406_14032)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3907 12.5C15.8297 12.4995 15.2701 12.5565 14.7207 12.67C15.5468 13.1379 16.2401 13.8085 16.7352 14.6186C17.2303 15.4286 17.511 16.3514 17.5507 17.3C17.5463 18.2621 17.2575 19.2015 16.7207 20C19.6607 19.89 22.0007 18.26 22.0007 16.26C22.0007 14.26 19.4907 12.5 16.3907 12.5Z",
    fill: "url(#paint3_linear_406_14032)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_406_14032",
    x1: 4.28906,
    y1: 6.7,
    x2: 13.7691,
    y2: 6.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_406_14032",
    x1: 2,
    y1: 17.3001,
    x2: 16.06,
    y2: 17.3001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_406_14032",
    x1: 13.8809,
    y1: 7.76,
    x2: 20.1724,
    y2: 7.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_406_14032",
    x1: 14.7207,
    y1: 16.25,
    x2: 22.0007,
    y2: 16.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile2User);
export default __webpack_public_path__ + "static/media/profile-2user.3e9b73da5086d68ef699e3d919acdfc2.svg";
export { ForwardRef as ReactComponent };